(function (root, factory) {
	if (typeof define === 'function' && define.amd) {
		define('deliveryZipcodeService', ['repositoryService', 'localizerConfig'], function (repositoryService, localizerConfig) {
			return factory(root, repositoryService, localizerConfig);
		});
	} else {
		root.deliveryZipcodeService = factory(root, repositoryService, localizerConfig);
	}
})(this, function (root, repositoryService, localizerConfig) {
	var determineZipcodeType = function (accuracy, deliveryZipTypeAutoExists) {
		var zipcodeType = 'AUTO';
		if (accuracy !== 'HIGH' && !deliveryZipTypeAutoExists) {
			zipcodeType = 'DEFAULT';
		}
		return zipcodeType;
	}
	var localConfig = localizerConfig.getConfig();
	/**
	 * @module deliveryZipcodeService
	 * @description Provides methods to get/set cookies related to delivery zip code.
	 * @type {Object}
	 */
	var deliveryZipcodeService = {
		updateDeliveryZipcodeFromLocalizerResponse: function (localizerResponse) {
			try {
				var deliveryZip = repositoryService.get('DELIVERY_ZIP');
				var deliveryZipTypeFromCookie = repositoryService.get('DELIVERY_ZIP_TYPE');
				var zipcodeType;
				if (!deliveryZip) {
					if (localizerResponse) {
						zipcodeType = determineZipcodeType(localizerResponse.status && localizerResponse.status.getAccuracy(), false);
						var localStorezip = localizerResponse.getLocalizedStore().zipcode;
						if (localStorezip) {
							this.updateDeliveryZipcodeDetails(localStorezip, zipcodeType);
						}
					}
				} else if (!deliveryZipTypeFromCookie) {
					var accuracy = localizerResponse && localizerResponse.status && localizerResponse.status.getAccuracy();
					zipcodeType = determineZipcodeType(accuracy, false);
					this.updateDeliveryZipcodeDetails(deliveryZip, zipcodeType);
				}
			} catch (error) {
				console.error(error);
			}
		  },
		  updateDeliveryZipcodeOnLocalizationWorkflow: function(localStore, accuracy){
			  try {
				  var deliveryZipType = this.getDeliveryZipcodeType();
				  if (!deliveryZipType || deliveryZipType.type !== 'USER') {		
					  var zipcodeType = determineZipcodeType(accuracy, deliveryZipType && deliveryZipType.type === 'AUTO');
					  this.updateDeliveryZipcodeDetails(localStore.address.postalCode, zipcodeType);
				  }
			  } catch (error) {
				  console.error(error); 
			}
		  },	
		/**
		 * Validates the zip code and calls the functions provided in the arguments based on the service reponse
		 * @param {string} zipcode 
		 * @param {string} successCallback function - Called if the zipcode provided is not valid 
		 * @param {string} failureCallback function - Called if the zipcode provided is not valid 
		 * @param {string} errorCallback function - Called of the service is not reachable/timeouts.
		 */
		validateUSZipcode: function (zipcode, successCallback, failureCallback, errorCallback) {
			try {
				var locationURL = localConfig.host + '/StoreSearchServices/v2/location?zipcode=' + zipcode + '&type=json';
				repositoryService.get(locationURL).then(
					function (result) {
						if (result && result.locations && result.locations.length > 0) {
							if (successCallback) {
								successCallback(result);
							}
						} else {
							if (failureCallback) {
								failureCallback(result);
							}
						}
					}, function(reject){
						if (errorCallback) {
							failureCallback(reject);
						}
					});
			} catch (error) {
				if (errorCallback) {
					errorCallback(error)
				}
			}
		},
		/**
		 * Updates the delivery zip code and type to the cookies 'DELIVERY_ZIP' and 'DELIVERY_ZIP'
		 * @param {String} deliveryZipCode 
		 * @param {String} type 
		 */
		updateDeliveryZipcodeDetails: function (deliveryZipcode, type) {
			try {
				var typeFromCookie = repositoryService.get('DELIVERY_ZIP_TYPE');
				if (deliveryZipcode) {
					repositoryService.put('DELIVERY_ZIP', deliveryZipcode);
				}
				if (type && typeFromCookie !== 'USER') {
					repositoryService.put('DELIVERY_ZIP_TYPE', type);
				}
			}
			catch (error) {
				console.error(error);
			}
		},
		/**
		 * Returns the object of delivery type, showndefault.
		 * Type can be one of the values - DEFAULT, AUTO or USER 
		 *     DEFAULT - If the zip code is set by auto localization
		 * 	   AUTO - If the zip code is set by auto localization and delivery tooltip is show to the user
		 * 	   USER - If the user sets the delivery zip explicitly	
		 */
		getDeliveryZipcodeType: function () {
			try {
				var typeFromCookie = repositoryService.get('DELIVERY_ZIP_TYPE');
				if (typeFromCookie) {
					var deliveryZipType = {
						type: typeFromCookie,
						shownDefault: (typeFromCookie !== 'DEFAULT')
					};
					return deliveryZipType;
				} else {
					return undefined;
				}
			}
			catch (error) {
				return undefined;
			}
		},
		/**
		 * Returns the delviery zip code, zip type and shownDefault values.
		 */
		getDeliveryZipcodeDetails: function () {
			var deliveryZipcode = repositoryService.get('DELIVERY_ZIP');
			var deliveryZipDetails = this.getDeliveryZipcodeType();
			if (deliveryZipDetails) {
				return {
					'zipcode': deliveryZipcode,
					'type': deliveryZipDetails.type,
					'shownDefault': deliveryZipDetails.shownDefault
				};
			} else {
				return {
					'zipcode': deliveryZipcode
				};
			}
		}

	}
	return deliveryZipcodeService;
});


//////////////////
// WEBPACK FOOTER
// ./src/deliveryZipcodeService.js
// module id = 12
// module chunks = 0